import { useQuery } from '@tanstack/react-query';
import ApiService from '../../ApiService';

const fetchData = async (codeGroup: string) => {
    const { data } = await ApiService.getCodes(codeGroup);
    return data;
};

const useCodeListQuery = (codeGroup: string) => {
    return useQuery({
        queryKey: ['codeList', codeGroup],
        queryFn: () => fetchData(codeGroup),
        staleTime: Infinity,
        enabled: !!codeGroup,
    });
};

export { useCodeListQuery };
